export default "__VITE_PUBLIC_ASSET__8802ef80__"